import { TRACKING_ID_PARAM_KEY } from '../helpers/searchParams'
import { useSearchParam } from './useSearchParam'

export const useTrackingIdParam = () => {
  const [trackingId, setTrackingId] = useSearchParam(TRACKING_ID_PARAM_KEY)
  return [trackingId ?? '', setTrackingId] as const
}
